import React, { useContext } from 'react'
import { BlogContext } from '@/lib/blocks/blog/BlogContext'

const usePagination = ({ items = [], itemsPerPage = 3 }) => {
	const { $pagination, set$pagination } = useContext(BlogContext)

	const atStart = $pagination === 0
	const atEnd = $pagination === Math.ceil(items.length / itemsPerPage) - 1
	const total = Math.ceil(items.length / itemsPerPage)

	const prev = () => {
		scrollTop()
		set$pagination(Math.max(0, $pagination - 1))
	}
	const next = () => {
		scrollTop()
		set$pagination(Math.min(Math.ceil(items.length / itemsPerPage) - 1, $pagination + 1))
	}

	const paginatedItems = items.slice(
		itemsPerPage * $pagination,
		itemsPerPage * ($pagination + 1)
	)

	const Pagination = ({ className, prevClassName, nextClassName }) => !(atStart && atEnd) && !!paginatedItems?.length && (
		<nav className={className}>
			<button
				className={prevClassName}
				onClick={prev}
				disabled={atStart}
			>Prev</button>

			<small>{$pagination + 1} of {total}</small>

			<button
				className={nextClassName}
				onClick={next}
				disabled={atEnd}
			>Next</button>
		</nav>
	)

	return {
		atStart, atEnd,
		prev, next,
		paginatedItems,
		Pagination,
	}
}

function scrollTop() {
	if (typeof window !== 'undefined') {
		window.scrollTo(0, 0)
	}
}

export default usePagination
